export enum TEMPLATES {
  BASE_WITH_HEADER = "top-bar_map-primary_hand-off",
}

export {};
